import { motion } from "framer-motion";
import { Search, Users, Handshake, BadgeCheck } from "lucide-react";

const chapters = [
    {
        n: "01",
        title: "We Understand Both Sides",
        icon: Search,
        body: "Every candidate has a story and every company has a need. We take time to understand skills, aspirations and role requirements before we ever make a match.",
    },
    {
        n: "02",
        title: "Skilled & Unskilled — All Welcome",
        icon: Users,
        body: "ITI, Diploma, Graduate, Post-Graduate, 10th/12th pass-outs or no formal education at all. Opportunity should never depend only on a certificate.",
    },
    {
        n: "03",
        title: "The Right Match, Fast",
        icon: Handshake,
        body: "Our network across Pune & Maharashtra means faster placements for job seekers and pre-screened, reliable talent for employers.",
    },
    {
        n: "04",
        title: "Trust You Can Rely On",
        icon: BadgeCheck,
        body: "A registered company (CIN 27CNVPB5057J1ZI) built on transparency, honest guidance and long-term relationships — not one-off transactions.",
    },
];

export const Manifesto = () => {
    return (
        <section
            id="manifesto"
            data-testid="manifesto-section"
            className="relative py-28 sm:py-36 px-5 sm:px-8"
        >
            <div className="mx-auto max-w-7xl grid lg:grid-cols-[0.9fr_1.5fr] gap-14">
                <div className="lg:sticky lg:top-32 lg:self-start">
                    <span className="text-xs tracking-[0.35em] text-[#F47B20] uppercase font-semibold">
                        Why Bhoir Group
                    </span>
                    <h2 className="mt-5 font-display text-4xl sm:text-5xl font-extrabold text-white leading-tight">
                        A workforce partner that puts{" "}
                        <span className="text-stroke">people first</span>.
                    </h2>
                    <p className="mt-6 text-slate-400 max-w-md leading-relaxed">
                        Four principles guide every placement we make — for the job seeker
                        walking through the door and the company trusting us to hire.
                    </p>
                </div>

                <div className="space-y-6">
                    {chapters.map((c, i) => {
                        const Icon = c.icon;
                        return (
                            <motion.div
                                key={c.n}
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.6, delay: i * 0.05 }}
                                data-testid={`manifesto-chapter-${c.n}`}
                                className="group glass rounded-2xl p-8 hover:border-[#F47B20]/40 transition-all duration-300 hover:-translate-y-1"
                            >
                                <div className="flex items-start gap-6">
                                    <span className="font-display text-5xl font-extrabold text-white/10 group-hover:text-[#F47B20]/60 transition-colors">
                                        {c.n}
                                    </span>
                                    <div>
                                        <div className="flex items-center gap-3 mb-2">
                                            <Icon size={20} className="text-[#F47B20]" />
                                            <h3 className="font-display text-xl font-bold text-white">
                                                {c.title}
                                            </h3>
                                        </div>
                                        <p className="text-slate-400 leading-relaxed">
                                            {c.body}
                                        </p>
                                    </div>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
